export const MODEL_TERM = {
    APR: 0,
    TERM: 1,
    DISCOUNT: 3,
    REBATE: 4,
    REBATE_AT_DELIVERY: 5,
    CASH_DOWN: 6,
    PAYMENT_FREQUENCIES: 7,
    RESIDUAL_RATE: 8,
    FINANCED_AMOUNT: 9,
    FINANCED_AMOUNT_WITH_TAXES: 10,
    RESIDUAL_AMOUNT: 11,
    CREDIT_RATE: 12,
    CREDIT_RATE_WITH_CASH_REBATE_ADJUSTMENT: 13,
    CREDIT_RATE_WITH_CASH_REBATE_ADJUSTMENT_TAXES: 14,
    INCLUDED_CODES: 15,
    REBATES_DETAILS: 16,
    REBATE_TAXES: 17,
    REBATE_TAXES_AT_DELIVERY: 18,
    REBATE_AT_STANDARD_RATE: 19,
};

export const COLLECTION_FREQUENCY = {
    PAYMENT_FREQUENCY: 0,
    BASE_PAYMENT: 1,
    FEES_PAYMENT: 2,
    DUTIES_PAYMENT: 3,
    PAYMENT_TAXES: 4,
    FINANCE_FACTOR: 5,
    BALLOON_FACTOR: 6,
    DISCLAIMERS: 12,
};

export const CALCULATOR_FREQUENCY = {
    PAYMENT_FREQUENCY: 'paymentPerYear',
    PAYMENT: 'payment',
    PAYMENT_TAXES: 'taxes',
    CASH_DOWN: 'cashDown',
    FINANCE_FACTOR: 'finFactor',
    BALLOON_FACTOR: 'balloonFactor',
    DISCLAIMER: 'disclaimer',
};

export const MODEL_FREQUENCY = {
    PAYMENT_FREQUENCY: 0,
    PAYMENT: 1,
    PAYMENT_TAXES: 2,
    FINANCE_FACTOR: 3,
    BALLOON_FACTOR: 4,
};

export const COLLECTION_FINANCE = {
    FINANCE: 'finance',
    LEASE: 'lease',
    INDEX: 0,
    TERMS: 6,
    BEST_TERM: 7,
    BEST_TERM_INDEX: 8,
    BEST_TERM_WITH_CASH: 9,
    BEST_TERM_WITH_CASH_INDEX: 10,
    PHOTO_URLS: 11,
    FINANCE_DISCLAIMERS: 12,
    LEASE_DISCLAIMERS: 18,
    LEASE_ANNUAL_KM: 12,
    LEASE_MAX_EXCEEDING_KM: 13,
    LEASE_MAX_TERM_KM: 14,
    LEASE_ALLOW_EXCEEDING_KM: 15,
    LEASE_MAX_TERM_EXCEEDING_KM: 16,
    LEASE_END_TERM_KM_COST: 17,
};

export const CALCULATOR_FINANCE = {
    VEHICLE: 'vehicle',
    FINANCE: 'finance',
    LEASE: 'lease',
};

export const VEHICLE_FINANCE = {
    FINANCE: 'finance',
    LEASE: 'lease',
    INDEX: 0,
    TERMS: 0,
};

export const MODEL_FINANCE = {
    FINANCE: 16,
    LEASE: 17,
    INDEX: 0,
    TERMS: 0,
    LEASE_ANNUAL_KM: 1,
    LEASE_MAX_EXCEEDING_KM: 2,
    LEASE_MAX_TERM_KM: 3,
    LEASE_ALLOW_EXCEEDING_KM: 4,
    LEASE_MAX_TERM_EXCEEDING_KM: 5,
    LEASE_END_TERM_KM_COST: 6,
};

export const MODEL_CASH_PURCHASE = {
    PRICING: 15,
    RETAIL: 0,
    DISCOUNTS: 1,
    REBATES: 2,
    REBATES_AT_DELIVERY: 3,
    INCLUDED_CODES: 4,
    REBATES_DETAILS: 5,
    REBATES_TAXES: 6,
    DEALER_FEES: 7,
};

export const VEHICLE_CASH_PURCHASE = {
    PRICING: 'price',
};

export const COLLECTION_CASH_PURCHASE = {
    PRICING: 'price',
    INDEX: 0,
    RETAIL: 6,
    REBATES: 7,
    AMOUNTS: 9,
    MSRP: 0,
    FREIGHT_PDI: 1,
    TAXES_AND_DUTIES: 2,
    DISCLAIMERS: 10,
    REBATES_DETAILS: 11,
    DISCOUNTS: 12,
    REBATES_AT_DELIVERY: 13,
    REBATES_TAXES: 14,
};

export const MODEL_TAXES = {
    TAXES_FACTOR: 21,
    TAX_CODES: 22,
};

export const REBATE_DETAILS = {
    REBATE_TYPE_ID: 0,
    REBATE_CODE: 1,
    REBATE_DESCRIPTION: 2,
    REBATE_AMOUNT: 3,
    REBATE_IS_AT_DELIVERY: 4,
    REBATE_IS_AFTER_TAXES: 5,
    REBATE_TAXES: 6,
    REBATE_TAXES_AT_DELIVERY: 7,
};

export default {
    MODEL_TERM,
    COLLECTION_FREQUENCY,
    CALCULATOR_FREQUENCY,
    MODEL_FREQUENCY,
    COLLECTION_FINANCE,
    CALCULATOR_FINANCE,
    VEHICLE_FINANCE,
    MODEL_FINANCE,
    MODEL_CASH_PURCHASE,
    VEHICLE_CASH_PURCHASE,
    COLLECTION_CASH_PURCHASE,
    MODEL_TAXES,
    REBATE_DETAILS,
};



// WEBPACK FOOTER //
// ./src/PurchaseMethods/constants/dataConversions.js